import request from "@/utils/request";
import Qs from "qs";

// 场地列表
export function placeList(data) {
  return request({
    url: "/place/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加场地
export function placeAdd(data) {
  return request({
    url: "/place/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑场地
export function placeEdit(data) {
  return request({
    url: "/place/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除场地
export function placeDel(data) {
  return request({
    url: "/place/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 场地详情
export function placeInfo(data) {
  return request({
    url: "/place/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 场地预约列表
export function placeApplyList(data) {
  return request({
    url: "/place/apply_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 场地预约详情
export function placeApplyInfo(data) {
  return request({
    url: "/place/apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 场地预约的操作（取消，通过）
export function placeApplyOperation(data) {
  return request({
    url: "/place/apply_operation",
    method: "post",
    data: Qs.stringify(data),
  });
}
